import { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Modal } from "@mui/material";
import MessageList from "./MessageList";
import MessageListFB from "./MessageListFB";
import MessageListIG from "./MessageListIG";
import { historyList } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";
import sent from "../Images/SingleCheckGray.svg";
import delivered from "../Images/DoubleCheckGray.svg";
import viewed from "../Images/DoubleCheckBlue.svg";
import pending from "../Images/PendingIcon.svg";
import renderBody from "../Helper/renderBody";

export default function ModalHistory({
  onClose,
  ChatListID,
  detailchat,
  FBID,
  GenerateNonPopUpFiles,
  IGID,
  WAID,
  isAllHistoryShown,
}) {
  const [hasMore, setHasMore] = useState(true);
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    // Get Stickers and Audio
    GenerateNonPopUpFiles &&
      GenerateNonPopUpFiles(history, detailchat?.Session);
  }, [history]);

  const statusSender = (status) => {
    let source;
    switch (status) {
      case "viewed":
        source = viewed;
        break;
      case "delivered":
        source = delivered;
        break;
      case "sent":
        source = sent;
        break;
      case "pending":
        source = pending;
        break;
      default:
        break;
    }
    if (source) {
      return (
        <span className="ChatRoombBody_status">
          <img src={source} alt={status} />
        </span>
      );
    }
  };

  const fetchDataHistory = async (ChatListID, page) => {
    const response = await historyList(ChatListID, page);
    if (response.status) {
      if (history.length > 0) {
        setHistory([...history, ...response.data.chatmessage]);
      } else setHistory(response.data.chatmessage ?? []);

      if (page === response.data.total_pages) setHasMore(false);
    } else {
      toast.warn(response.error);
    }
  };

  const nextFetch = () => {
    if (hasMore) {
      fetchDataHistory(ChatListID, page + 1);
      setPage(page + 1);
    }
  };

  useEffect(() => {
    (!FBID && !IGID && !WAID) && fetchDataHistory(ChatListID, 1);
  }, []);

  return (
    <Modal open onClose={onClose}>
      <div className="modalContainerHistory">
        <div className="header-container">
          <div className="header">
            <h1>Show History</h1>
            <CloseOutlined className="close-button" onClick={onClose} />
          </div>
        </div>

        {history.length > 0 && (
          <div className="listContainerModalHistory" id="scrollableDiv3">
            <InfiniteScroll
              dataLength={history.length}
              next={nextFetch}
              style={{
                display: "flex",
                flexDirection: "column-reverse",
                overflow: "none",
              }}
              inverse={true}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv3"
            >
              {history.length > 0
                ? history.map((item) => {
                    return (
                      <div key={item.RecordID}>
                        <div
                          className={
                            item.FromMe === false
                              ? "ChatRoombBody_message"
                              : "ChatRoombBody_receiver"
                          }
                        >
                          <div className="ChatRoombBody_grid">
                            <div className="ChatRoombBody_flex">
                              <span
                                className={
                                  item.FromMe === false
                                    ? "ChatRoombBody_name"
                                    : "ChatRoombBody_nameReceiver"
                                }
                              >
                                {item.senderName}
                              </span>
                              {renderBody(
                                item.RecordID,
                                item.Body,
                                item.type,
                                item.FileName,
                                item.caption,
                                item.quotedMsgBody,
                                true
                              )}
                            </div>
                            <div className="ChatRoombBody_left">
                              <div className="ChatRoombBody_flex">
                                <span className="ChatRoombBody_timestamp">
                                  {moment
                                    .utc(item.time)
                                    .format("DD MMM yyy HH:mm")}
                                </span>

                                {item.FromMe === true
                                  ? statusSender(item.StatusName)
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : ""}
            </InfiniteScroll>
          </div>
        )}

        {WAID && (
          <MessageList
            chatListID={ChatListID}
            WAID={WAID}
            isAllHistoryShown={isAllHistoryShown}
          />
        )}

        {FBID && <MessageListFB chatListID={ChatListID} FBID={FBID} />}
        {IGID && <MessageListIG chatListID={ChatListID} IGID={IGID} />}
      </div>
    </Modal>
  );
}
